import { FDSwitchInput } from '@facet-wealth/design';
import fr from 'facet-rest';
import { GoalDetailOverride } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalDetail/MetaOverride';

export const SaveForRetirementOverride = fr.metaOverride({ base: GoalDetailOverride })
  .typeOverride('bool', {
    _component: () => FDSwitchInput,
    _customProps: { helperText: '' },
  });
